import { connect } from 'react-redux';

import { actionCreators as actions } from 'dux/usersManagement';
import getUsersManagementState from 'dux/usersManagement/selectors';

import InviteUserCard from './InviteUserCard';

const mapStateToProps = (state) => ({
  ...getUsersManagementState(state),
});

const mapDispatchToProps = {
  deleteUserInviteState: actions.deleteUserInviteState,
  resendUserInviteState: actions.resendUserInviteState,
};

export default connect(mapStateToProps, mapDispatchToProps)(InviteUserCard);
